import { render, staticRenderFns } from "./banjiHome.vue?vue&type=template&id=333b4a40&scoped=true"
import script from "./banjiHome.vue?vue&type=script&lang=js"
export * from "./banjiHome.vue?vue&type=script&lang=js"
import style0 from "./banjiHome.vue?vue&type=style&index=0&id=333b4a40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../youyidian_pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333b4a40",
  null
  
)

export default component.exports